'use strict';

import * as angular from 'angular';
var app = angular.module('noc.trainSchedule', []);

app.controller('TrainScheduleController', require('./trainScheduleController'));
app.factory('TrainScheduleCrudFactory', require('./trainScheduleCrudFactory'));
app.controller('TrainScheduleEntryDetailsController', require('./trainScheduleEntryDetails'));
app.factory('TrainScheduleExportFactory', require('./trainScheduleExportFactory'));
app.factory('TrainScheduleFactory', require('./trainScheduleFactory'));

export default app;